module.exports = __webpack_public_path__ + "static/img/setup_git_bash_options.996da61.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/python/images/setup_git_bash_options.png
// module id = /4PE
// module chunks = 1